import { library, dom } from '@fortawesome/fontawesome-svg-core'

import {
  faBars as fasBars,
  faTimes as fasTimes,
  faIcons as fasIcons,
  faRecycle as fasRecycle,
  faTachometerAlt as fasTachometerAlt,
  faBurn as fasBurn,
  faTint as fasTint,
  faExpandArrowsAlt as fasExpandArrowsAlt,
  faBoxes as fasBoxes,
  faHammer as fasHammer,
  faBuilding as fasBuilding,
  faAnchor as fasAnchor,
  faPallet as fasPallet,
  faTruck as fasTruck,
  faShip as fasShip,
  faPlug as fasPlug,
  faDumpster as fasDumpster,
  faArrowsAltH as fasArrowsAltH,
  faWater as fasWater,
  faExchangeAlt as fasExchangeAlt,
  faTools as fasTools,
  faDolly as fasDolly,
  faTruckLoading as fasTruckLoading,
  faImage as fasImage,
  faPencil as fasPencil,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faChevronRight as falChevronRight,
  faChevronLeft as falChevronLeft,
} from '@fortawesome/pro-light-svg-icons'

library.add(
  fasBars,
  fasTimes,
  falChevronRight,
  falChevronLeft,
  fasIcons,
  fasRecycle,
  fasTachometerAlt,
  fasBurn,
  fasTint,
  fasExpandArrowsAlt,
  fasBoxes,
  fasHammer,
  fasBuilding,
  fasAnchor,
  fasPallet,
  fasTruck,
  fasShip,
  fasPlug,
  fasDumpster,
  fasArrowsAltH,
  fasWater,
  fasExchangeAlt,
  fasTools,
  fasDolly,
  fasTruckLoading,
  fasImage,
  fasPencil,
)

dom.watch()
